import React, {Component} from 'react';
import axios from 'axios';
import clsx from 'clsx';
import { UserContext } from '../components/userContext';
import { useHistory, withRouter } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Container, IconButton } from '@material-ui/core';
import Rating from '@material-ui/lab/Rating';
import { withStyles } from '@material-ui/styles';
import OpenInNewRoundedIcon from '@material-ui/icons/OpenInNewRounded';
import { Block, Translate } from '@material-ui/icons';


const useStyles = (theme) => ({
  root: {
    overflowX: 'hidden',
    width: 'calc(100vw - 240px)', 
    margin: '0 auto', 
    '@media (max-width:950px)': {
      width: 'calc(100vw - 87px)',
    },
    '@media (max-width:775px)': {
      width: '100%'
    },
  },
  rootOpen: {
    width: 'calc(100vw - 240px - 240px)', 
    '@media (max-width:950px)': {
      width: '100%'
    },
  },
  detail: {
    transition: 'all 0.5s ease',
    boxSizing: 'border-box',
    minHeight: 300,
    paddingRight: 35,
    fontSize: 16,
    transform: 'translateX(355px)',
    // overflow: 'hidden',
    width: 'calc(100vw - 320px - 240px - 35px - 2px)',
    '@media (max-width:950px)': {
      width: 'calc(100vw - 320px - 87px - 35px - 2px)',
    },
    '@media (max-width:775px)': {
      width: '100%',
      transform: 'translate(0px, 0px)',
      // background: 'linear-gradient(0deg, rgba(8, 8, 8, 0.975) 75%, transparent)',
      backgroundColor: 'rgba(8, 8, 8, 0.975)',
      boxShadow: theme.shadows[8],
      padding: 30,
      fontSize: 15,
      // paddingTop: 300,
      height: '100%',
    },
    '@media (max-width:599px)': {
      padding: 12,
      // paddingTop: 300,
      fontSize: 14,
    },
    '& .imgMobile': {
      display: 'none',
      // borderRadius: 4,
      height: 240,
      marginBottom: 16,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      '@media (max-width:775px)': {
        display: 'block'
      },
    },
    '& .imgMobileOpen': {
      '@media (max-width:1000px)': {
        display: 'block'
      },
    },
    '& .name': {
      fontSize: 36, 
      fontWeight: 500, 
      lineHeight: '36px',
      marginBottom: 8,
      '@media (max-width:775px)': {
        fontSize: 28, 
        lineHeight: '28px',
      },
      '@media (max-width:599px)': {
        fontSize: 24, 
        lineHeight: '24px',
      }
    },
    '& .genre span': {
      backgroundColor: 'rgb(163, 102, 255)',
    },
    '& .platform span': {
      backgroundColor: 'rgb(102, 102, 255)',
    },
    '& .mode span': {
      backgroundColor: 'rgb(204, 102, 204)',
    },
    '& .genre, .platform, .mode': {
      '& span': {
        display: 'inline-flex',
        padding: '2px 5px', 
        marginRight: 8,
        borderRadius: 2,
        color: 'rgba(0, 0, 0, 1)',
        fontWeight: 450,
        marginBottom: 12,
        boxShadow: theme.shadows[3],
      },
      '& span:first-child': {
        backgroundColor: 'transparent',
        boxShadow: 'none',
        padding: 0,
        color: 'rgb(144, 144, 144)',
        marginBottom: 4,
        // backgroundColor: 'rgb(255, 153, 0)',
        display: 'block',
      },
    },
  },
  detailOpen: {
    width: 'calc(100vw - 320px - 240px - 240px - 35px - 2px)',
    '@media (max-width:1000px)': {
      width: '100%',
      transform: 'translate(0px, 0px)',
      // background: 'linear-gradient(0deg, rgba(8, 8, 8, 0.975) 75%, transparent)',
      backgroundColor: 'rgba(8, 8, 8, 0.975)',
      boxShadow: theme.shadows[8],
      padding: 30,
      fontSize: 15,
      // paddingTop: 300,
      height: '100%',
    },
  },
  container: {
    width: 'calc(100vw - 240px - 35px)',
    '@media (max-width:950px)': {
      width: 'calc(100vw - 87px - 35px)',
    },
    '@media (max-width:775px)': {
      transform: 'translateX(0px)',
      width: '100%'
    },
    transform: 'translateX(35px)',
    boxShadow: theme.shadows[8],
    backgroundColor: 'rgba(8, 8, 8, 0.975)',
    // border: '4px solid rgba(8, 8, 8, 0.975)',
    '& .innerContainerOpen': {
      width: 'calc(100vw - 240px - 240px - 35px)', 
      '@media (max-width:1000px)': {
        width: '100%',
        padding: 0,
      },
    },
    '& .innerContainer': {
      height: '100%', 
      width: 'calc(100vw - 240px - 35px)', 
      padding: '35px 0', 
      '@media (max-width:950px)': {
        width: 'calc(100vw - 87px - 35px)',
      },
      '@media (max-width:775px)': {
        width: '100%',
        padding: 0,
      },
    },
    '& .imgContainerOpen': {
      width: '100%',
      transform: 'translateX(0px)',
      '@media (max-width:1000px)': {
        transform: 'translateX(0px)',
        width: '100%',
        height: '100%'
      },
    },
    '& .imgContainer': {
      transition: 'all 0.5s ease',
      boxSizing: 'border-box',
      width: 320,
      transform: 'translateX(-35px)',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      border: '2px solid rgba(8, 8, 8, 0.975)',
      boxShadow: theme.shadows[3],
      backgroundColor: 'rgba(8, 8, 8, 0.975)',
      '@media (max-width:775px)': {
        transform: 'translateX(0px)',
        width: '100%',
        height: '100%'
      },
      '@media (max-width:599px)': {
        minWidth: 270,
      },
    },
  },
  containerOpen: {
    width: 'calc(100vw - 240px - 240px - 35px)',
    '@media (max-width:1000px)': {
      width: '100%',
      transform: 'translateX(0px)',
    },
  },
});

class GameDetail extends React.Component { 
	static contextType = UserContext;
  
  constructor(props) {
    super(props);
    this.state = {
      game: {},
    }
  }

  componentDidMount() {
    const itemId = this.props.match.params.itemId;
    console.log(itemId)
    axios.get(`https://backendexample.sanbersy.com/api/data-game/${itemId}`).then(res => {
      let result = res.data;
      if (Boolean(result.name) === false) result.name = " ";
      if (Boolean(result.genre) === false) result.genre = " ";
      if (Boolean(result.release) === false) result.release = " ";
      if (Boolean(result.platform) === false) result.platform = " ";
      if (Boolean(result.singlePlayer) === false) result.singlePlayer = 0;
      if (Boolean(result.multiplayer) === false) result.multiplayer = 0;
      let name = result.name.charAt(0).toUpperCase() + result.name.slice(1)
      let genre = result.genre.charAt(0).toUpperCase() + result.genre.slice(1)
      let platform = result.platform.charAt(0).toUpperCase() + result.platform.slice(1)
      this.setState({game: {...result, name: name, genre: genre, platform: platform} });   
    });
  }

  render() {
    const { classes } = this.props;
    const { open } = this.context;
    return(
      <div className={clsx(classes.root, open && classes.rootOpen)}>
        <div className={clsx(classes.container, open && classes.containerOpen)}>
          <div className={clsx("innerContainer", open && "innerContainerOpen")}>
            <div className={clsx("imgContainer", open && "imgContainerOpen")} style={{backgroundImage: `url(${this.state.game.image_url})`}} >
              <div className={clsx(classes.detail, open && classes.detailOpen)}>
                <div className={clsx("imgMobile", open && "imgMobileOpen")} style={{backgroundImage: `url(${this.state.game.image_url})`}} ></div>
                <div className='name'>{this.state.game.name} ({this.state.game.release})</div>
                {this.state.game.genre && 
                  <div className="genre"> 
                    <span>Genre :</span>
                    {this.state.game.genre.includes(',') 
                      ? this.state.game.genre.split(',').map((el, idx) => {
                        return (
                          <span>
                            {el.trim().charAt(0).toUpperCase() + el.trim().slice(1)}
                          </span> 
                        )}) 
                      : <span>{this.state.game.genre.trim().charAt(0).toUpperCase() + this.state.game.genre.trim().slice(1)}</span>
                    }
                  </div>
                }

                {this.state.game.platform && 
                  <div className="platform">
                    <span>Platform : </span>
                    {this.state.game.platform.includes(',') 
                      ? this.state.game.platform.split(',').map((el, idx) => {
                        return (
                          <span>
                            {el.trim().charAt(0).toUpperCase() + el.trim().slice(1)}
                          </span> 
                        )}) 
                      : <span>{this.state.game.platform.trim().charAt(0).toUpperCase() + this.state.game.platform.trim().slice(1)}</span>
                    }
                  </div>
                }

                <div className="mode">
                  <span>Game Mode :</span>
                  {this.state.game.singlePlayer === 1 ?
                    <span>Single Player</span> : null
                  }
                  {this.state.game.multiplayer === 1 ? 
                    <span>Multi Player</span> : null
                  }
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }   
}

export default withStyles(useStyles)(GameDetail);
 